import * as React from "react";
const SvgFiRrVideoCamera = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-video-camera_svg__a)">
      <path
        fill="#062147"
        d="M22.9 8.955a1.99 1.99 0 0 0-2.092.184L18.975 10.5A5.007 5.007 0 0 0 14 6h-.085L9.793 1.879A2.98 2.98 0 0 0 7.672 1H1a1 1 0 0 0 0 2h6.672c.265 0 .52.106.707.293L11.086 6H5a5.006 5.006 0 0 0-5 5v8a5.006 5.006 0 0 0 5 5h9a5.007 5.007 0 0 0 4.975-4.5l1.83 1.364a2 2 0 0 0 3.2-1.6v-8.521A1.99 1.99 0 0 0 22.9 8.955M17 19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3zm5 .257-3-2.236v-4.042l3-2.236z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-video-camera_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVideoCamera;
